import * as React from 'react';

import Registry from '../../../global/Registry';
import ListeningComponent from '../../../../foundation/components/ListeningComponent';
import AppEvent from '../../../../foundation/events/AppEvent';
import UserSignedUp from '../../../modules/users/domain/aggregates/user/events/UserSignedUp';
import User from '../../../modules/users/domain/aggregates/user/User';
import UserSignedIn from '../../../modules/users/domain/aggregates/user/events/UserSignedIn';
import UserApi from '../../../modules/users/api/UserApi';
import UserSignedOut from '../../../modules/users/domain/aggregates/user/events/UserSignedOut';
import { Menu, Dropdown, Icon } from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import Page from '../../Page';

interface Props {
	pageName: string;
}

interface State {
	user: User;
}

export default class PageHeaderComponent extends ListeningComponent<Props, State> {

	public constructor () {
		super();

		this.state = {user: Registry.getInstance().me};
	}

	public async processEvent (event: AppEvent) {
		if (event instanceof UserSignedUp || event instanceof UserSignedIn || event instanceof UserSignedOut) {
			this.forceUpdate();
		}
	}

	signOut = async () => {
		await UserApi.getInstance().signOut();
		window.location.href = '/';
	}

	render () {
		const user = Registry.getInstance().me;
		const pageName = this.props.pageName;

		return (
			<div>
				<Menu className='top big fixed topmenu inverted'>
					<Link to='/'><Menu.Item header><img style={{marginTop: '-20px', marginBottom: '-20px', marginRight: '4px'}} src='/logo.svg' /> {'Brain Brooder'}</Menu.Item></Link>
					{user !== undefined && user.isSignedUp() ?
						<Menu.Menu position='right'>
							<Dropdown item text={user.getDisplayName() as string}>
								<Dropdown.Menu>
									<Dropdown.Item onClick={() => Page.navigate('/change-password')}><Icon name={'lock'} /> Change password</Dropdown.Item>
									<Dropdown.Item onClick={() => Page.navigate('/preferences')}><Icon name={'cogs'} /> Preferences</Dropdown.Item>
									<Dropdown.Divider style={{borderColor: 'grey'}} />
									<Dropdown.Item onClick={this.signOut}><Icon name={'sign out'} /> Sign out</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</Menu.Menu>
						:
						<Menu.Menu position='right'>
							<Link to='/sign-in'><Menu.Item active={pageName === 'SignIn'}><Icon name='sign in'/> Sign in</Menu.Item></Link>
							<Link to='/sign-up'><Menu.Item active={pageName === 'SignUp'}><Icon name='user'/> Sign up</Menu.Item></Link>
						</Menu.Menu>
					}
				</Menu>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/PageHeaderComponent.tsx